export default __webpack_public_path__ + "static/media/Video.edfb4265.svg";